module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "closeBtn",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("关闭")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middleImg"
  }, [_c('div', {
    staticClass: "vedioPosition left"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "346px"
    },
    attrs: {
      "src": require("../../site/vedio.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "126px"
    },
    attrs: {
      "src": require("../../site/loveIcon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right",
    staticStyle: {
      "width": "500px"
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "margin-top": "90px",
      "width": "350px"
    },
    attrs: {
      "src": require("../../site/ttqLogo1.png")
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "margin-top": "90px",
      "width": "200px"
    },
    attrs: {
      "src": require("../../site/slingUpdataErcode.png?1")
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d8fe60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/client.vue
// module id = 182
// module chunks = 1